"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentType = void 0;
var PaymentType;
(function (PaymentType) {
    PaymentType["SUBSCRIPTION"] = "subscription";
    PaymentType["RENT"] = "rent";
    PaymentType["PURCHASE"] = "sale";
    PaymentType["MEMBER_ONLY"] = "memberOnly";
    PaymentType["PLAN"] = "plan";
})(PaymentType = exports.PaymentType || (exports.PaymentType = {}));
//# sourceMappingURL=payment-type.js.map